import { render, staticRenderFns } from "./MyQuickLinks.vue?vue&type=template&id=2329b342&"
import script from "./MyQuickLinks.vue?vue&type=script&lang=js&"
export * from "./MyQuickLinks.vue?vue&type=script&lang=js&"
import style0 from "./MyQuickLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports